<template>
  <div v-autofocus class="forgotten-password-form">
    <validation-observer ref="forgottenPasswordForm"
                         tag="form"
                         @submit.prevent="submitForgottenPasswordForm">
      <div class="form-fields">
        <base-v-input v-model.trim="emailInput"
                      id="email"
                      ref="email"
                      container-class="email-input"
                      name="email"
                      :submitted="loginFormSubmitted"
                      :label="$t('forgottenPassword.emailLabel')"
                      rules="required|noSpaces|email"
                      vid="email">
        </base-v-input>
        <div class="form-links">
          <a class="back-link" :href="loginLink">
            <img class="back-arrow" src="../../assets/images/mtel_small_arrow_left.png" alt="">
            {{ $t('forgottenPassword.backToLogin') }}
          </a>
          <base-button :disabled="!emailInput.length || buttonDisabled" :loading="dataLoading" class="send-btn"
                       type="submit">
            {{ $t('forgottenPassword.send') }}
          </base-button>
        </div>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { makeQueryString } from '@/utils/queryParser'
import { customRouter } from '@/customRouter'

export default {
  name: 'forgotten-password-form',
  data () {
    return {
      emailInput: '',
      loginFormSubmitted: false,
      buttonDisabled: false,
      dataLoading: false
    }
  },
  computed: {
    loginLink () {
      return customRouter.getRouteByName({ name: 'login' })
    }
  },
  methods: {
    async submitForgottenPasswordForm () {
      const formValid = await this.$refs.forgottenPasswordForm.validate()
      this.loginFormSubmitted = true

      if (formValid) {
        this.$apiRequest.put('user/password/forgottenpassword', { userId: this.emailInput })
          .then(response => {
            if (response.status >= 200 && response.status < 400) {
              customRouter.goTo({ name: 'forgottenPasswordConfirmation' }, makeQueryString({ email: this.emailInput }))
            }
          })
          .catch(e => {
            if (e.response.data.errors && e.response.data.errors.length) {
              this.toast('error', {
                message: e.response.data.errors[0].message || this.$t('errors.defaultError')
              })
            } else {
              this.toast('error', {
                message: this.$t('errors.serverError')
              })
            }
          })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.forgotten-password-form {
  background: $white;
  border-radius: 5px;
  width: 100%;
  padding: 2.4rem;
  flex: 1 1 auto;

  @media (map_get($breakpoints, sm)) {
    padding: 4rem;
    margin-top: 6rem;
    max-width: 44rem;
    flex: 0 0 auto;
  }

  .form-links {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 1.5rem;
    flex-direction: column;

    .back-link {
      font-weight: 600;
      text-decoration: none;
      color: $mtel-red;
      font-size: 1.6rem;
      order: 2;
      width: 100%;
      text-align: left;
      margin-bottom: 1rem;

      @media (map_get($breakpoints, sm)) {
        order: 1;
        margin-bottom: 0;
      }
    }

    .back-arrow {
      margin-right: 1rem;
    }

    @media (map_get($breakpoints, sm)) {
      flex-direction: row;
    }

    .send-btn {
      order: 1;
      width: 100%;
      margin-bottom: 2.4rem;

      @media (map_get($breakpoints, sm)) {
        order: 2;
        width: auto;
        margin-bottom: 0;
      }
    }
  }
}

</style>
